module.exports = __webpack_public_path__ + "img/李淼.27cc196a.jpg";